import { useEffect, useState } from "react";
import { useConfig } from "../../../contexts/useConfig";
import ActionButtonStandard from "../Action/ActionButtonStandard";
import { ReactComponent as DimensionsIcon } from "../../../assets/icons/measure_icon.svg";
import { useViewerMode } from "../../../contexts/useViewerMode";
import { useLocalSessionSettings } from "../../../contexts/useLocalSessionSettings";
import ReactGA from "react-ga4";


export default function DimensionsButton() {
   const [config] = useConfig();
   const [viewerMode, ,setViewerMode] = useViewerMode();
   const [localSessionSettings, updateSettings] = useLocalSessionSettings();
   const [buttonActive, setButtonActive] = useState(localSessionSettings.showDimensions);


   useEffect(() => {
      setButtonActive(localSessionSettings.showDimensions)
   }, [localSessionSettings.showDimensions])
   function handleClick() {
      if (viewerMode === "select") {
         setViewerMode("view");
      }

      const newButtonState = !buttonActive;
      setButtonActive(newButtonState);


      let sessionSettings = {};      
      sessionSettings.showDimensions = newButtonState

      if (newButtonState === true) {
         sessionSettings.togglePartsActive = true;
      }

      updateSettings(sessionSettings);

      ReactGA.event({
         category: "Dimensions Button",
         action: `Toggle Dimensions`,
         label: newButtonState ? "true" : "false"
      });
   }

   return (
      config?.dimensionsConfig?.enabled && (
         <ActionButtonStandard
            className={buttonActive ? "dimensionsButton highlight" : "dimensionsButton"}
            iconImg={<DimensionsIcon />}
            useSvgIcon={true}
            onClick={handleClick}
         />
      )
   );
}
